import MainTitle from "@/components/MainTitle";
import CardList from "@/pages/blog-news/CardList";
import { Row, Col, Input, Button, Space } from 'antd';
import { useEffect, useState } from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { event_list } from "@/apis/event";
import intl from "react-intl-universal";

const News = () => {
	const [params, setParams] = useState({})
	const [pageParam, setPageParam] = useState({
		pageSize: 10,
		currentPage: 1,
	})
	const [list, setList] = useState([])
	const [total, setTotal] = useState(0)
	const getList = () => {
		event_list({
			...params,
			...pageParam,
			status:1
		}).then((res) => {
			const arr = res.data.records.map(item => {
				return {
					id: item.eventsUuid,
					type: item.eventsType,
					title: item.title,
					des: item.text,
					date: item.phenomenonTime,
					link: item.link,
					imgPath: item.cover?.filePath,
				}
			})
			setList(arr);
			setTotal(res.data.total)
		}).catch(err => { })
	}

	useEffect(() => {
		getList()
	}, [pageParam])
	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			handleQuery()
		}
	}

	const handleQuery = () => {
		setPageParam({ currentPage: 1,...pageParam })
	}

	return (
		<div className={classNames("container", styles.eventsBox)}>
			<MainTitle title="Events" />
			<Row gutter={30} className={styles.rowBox}>
				<Col span={24}>
					<Space.Compact size="large" style={{ width: '100%' }}>
						<Input
							allowClear
							placeholder={intl.get("Title")}
							onKeyDown={handleKeyDown}
							onChange={(e) => {
								setParams({ keywords: e.target.value })
							}} />
						<Button type="primary" onClick={handleQuery}>{intl.get("Search")}</Button>
					</Space.Compact>
				</Col>
			</Row>
			<CardList list={list} pageParam={pageParam} total={total} setPageParam={setPageParam} type="EVENTS" />
		</div>
	);
}
export default News;